import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login';
import SupplierList from './components/SupplierList';
import OfflineCRUD from './components/OfflineCRUD';
import Sidebar from './components/Sidebar';
import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ResetPassword';
import Register from './components/Register';
import EmailVerified from './components/EmailVerified';

function ProtectedLayout({ children, onLogout }) {
  return (
    <Sidebar onLogout={onLogout}>
      {children}
    </Sidebar>
  );
}

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(!!localStorage.getItem("auth_token"));

  const handleLogout = () => {
    localStorage.removeItem("auth_token");
    setIsAuthenticated(false);
  };

  return (
    <Router>
      <Routes>
        {/* Public Routes */}
        {!isAuthenticated && (
          <>
            <Route path="/login" element={<Login onLogin={() => setIsAuthenticated(true)} />} />
            <Route path="/register" element={<Register />} />
            <Route path="/email-verified" element={<EmailVerified />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password/:token" element={<ResetPassword />} />
            <Route path="*" element={<Navigate to="/login" />} />
          </>
        )}

        {/* Protected Routes */}
        {isAuthenticated && (
          <>
            <Route
              path="/suppliers"
              element={
                <ProtectedLayout onLogout={handleLogout}>
                  <SupplierList onLogout={handleLogout} />
                </ProtectedLayout>
              }
            />
            <Route
              path="/offline-crud"
              element={
                <ProtectedLayout onLogout={handleLogout}>
                  <OfflineCRUD />
                </ProtectedLayout>
              }
            />
            <Route path="*" element={<Navigate to="/suppliers" />} />
          </>
        )}
      </Routes>
    </Router>
  );
}

export default App;
